/* eslint-disable react/prop-types */
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, Divider, Grid, IconButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { CancelPresentationRounded } from '@mui/icons-material';
import styles from './style';

const ActionConfirmationDialog = ({ open, handleClose, confirmationText, handleConfirm, data }) => {
  const classes = styles();

  return (
      <Dialog
        open={open}
        onClose={() => {
          handleClose(false);
        }}
        fullWidth={true}
        className={classes.dialogModal}
      >
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '1.3rem' }}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item>Attention!</Grid>
              <Grid item>
                <IconButton
                  onClick={() => {
                    handleClose(false);
                  }}
                >
                  <CancelPresentationRounded fontSize='large' />
                </IconButton>
              </Grid>
            </Grid>
          </Typography>
        </Box>
        <Divider />
        <DialogContent style={{ marginTop: '2px' }}>
          <DialogContentText align='center' style={{ marginLeft: '-0.7rem' }} color={'black'} fontSize={'20px'} id="alert-dialog-description">
            {confirmationText}
          </DialogContentText>
        </DialogContent>
        <Grid container item justifyContent='center' marginBottom='2rem'>
          <DialogActions>
            <Button
              className={classes.button}
              onClick={() => {
                handleClose();
              }}
            >
              No
            </Button>
             <Button
              className={classes.button}
              onClick={() => {
                handleConfirm(data);
              }}
            >
              Yes
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>
  );
};

ActionConfirmationDialog.propTypes = {
  open: PropTypes.any,
  handleClose: PropTypes.any,
  confirmationText: PropTypes.string,
  handleConfirm: PropTypes.func,
  data: PropTypes.any
};

export default ActionConfirmationDialog;
